import React from 'react';
import './PricingSection.css';

const PricingSection: React.FC = () => {
  return (
    <section className="pricing-section">
      <div className="pricing-container">
        {/* Notification Bar */}
        <div className="pricing-notification-bar">
          <span className="pricing-notification-text">Boost your productivity</span>
        </div>
        
        {/* Content Frame */}
        <div className="pricing-content">
          <div className="pricing-text-content">
            <h2 className="pricing-heading">A more effective way to track progress</h2>
            <p className="pricing-description">
              Effortlessly turn your ideas into a fully functional, responsive, 
              no-code SaaS website in just minutes with the set of free components for Framer.
            </p>
          </div>
          
          {/* Pricing Cards */}
          <div className="pricing-cards">
            {/* Free Plan */}
            <div className="pricing-card">
              <div className="pricing-card-content">
                <div className="pricing-header">
                  <span className="plan-subtitle">Free</span>
                  <div className="price-container">
                    <span className="price">$0</span>
                    <span className="price-period">/monthly</span>
                  </div>
                  <button className="pricing-btn">Get started for free</button>
                </div>
                
                <div className="features-list">
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Up to 5 project members</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Unlimited tasks and projects</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>2GB storage</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Integrations</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Basic support</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Pro Plan (Most Popular) */}
            <div className="pricing-card pro-card">
              <div className="pricing-card-content">
                <div className="pricing-header">
                  <div className="plan-header-with-badge">
                    <span className="plan-subtitle">Pro</span>
                    <div className="most-popular-badge">
                      <span>Most Popular</span>
                    </div>
                  </div>
                  <div className="price-container">
                    <span className="price">$9</span>
                    <span className="price-period">/monthly</span>
                  </div>
                  <button className="pricing-btn">Sign up now</button>
                </div>
                
                <div className="features-list">
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Up to 50 project members</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Unlimited tasks and projects</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>50GB storage</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Integrations</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Priority support</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Advanced support</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Export support</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Business Plan */}
            <div className="pricing-card">
              <div className="pricing-card-content">
                <div className="pricing-header">
                  <span className="plan-subtitle">Business</span>
                  <div className="price-container">
                    <span className="price">$19</span>
                    <span className="price-period">/monthly</span>
                  </div>
                  <button className="pricing-btn">Sign up now</button>
                </div>
                
                <div className="features-list">
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Up to 5 project members</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Unlimited tasks and projects</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>200GB storage</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Integrations</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Dedicated account manager</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Custom fields</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Advanced analytics</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Export capabilities</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>API access</span>
                  </div>
                  <div className="feature-item">
                    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Advanced security features</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection; 